interface AvatarProps {
  name: string;
  size?: "xs" | "sm" | "md" | "lg" | "xl";
  className?: string;
}

const sizeMap = {
  xs: "w-7 h-7 text-[11px] rounded-md",
  sm: "w-9 h-9 text-[12px] rounded-lg",
  md: "w-11 h-11 text-[14px] rounded-[12px]",
  lg: "w-12 h-12 text-[15px] rounded-[12px]",
  xl: "w-14 h-14 text-[17px] rounded-[14px]",
};

function initials(name: string) {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "?";
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

// Nøytral monogram — rolig, profesjonell (Linear/Stripe-stil)
export default function Avatar({ name, size = "md", className = "" }: AvatarProps) {
  return (
    <div
      className={`${sizeMap[size]} font-semibold inline-flex items-center justify-center shrink-0 border border-line ${className}`}
      style={{ background: "#F4F4F5", color: "#52525B" }}
    >
      {initials(name || "?")}
    </div>
  );
}
